// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// In-Memory Interaction Counter
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

/**
 * Tracks completed conversation interactions for the current page session.
 * This counter only increments on successful conversation completions,
 * not on cancelled or failed requests.
 *
 * The counter is stored in memory and will reset on page refresh.
 */

// Single counter for the current page session
let interactionCount = 0;

/**
 * Get the current interaction count
 * @returns The current interaction count
 */
export function getInteractionCount(): number {
  return interactionCount;
}

/**
 * Increment the interaction count and return the new count
 * @returns The new interaction count after incrementing
 */
export function incrementInteractionCount(): number {
  interactionCount += 1;
  return interactionCount;
}

/**
 * Reset the interaction count back to 0
 */
export function resetInteractionCount(): void {
  interactionCount = 0;
}